import * as React from 'react';
import {useEffect} from 'react';
import System from 'src/helper/system';
import {useBOMStore} from 'src/hooks/bom';
import useReduxState from 'src/hooks/useReduxState';

const BomName = (props) => {

    const [{bom_detail_by_bom_id}, {get_bom_detail_by_bom_id}] = useBOMStore();

    const [isEdit, setIsEdit] = useReduxState(false, 'setIsEdit');

    const bom_id = System.getParams().bomId

    const editHandler = (status) => {
        setIsEdit(status);
    };

    useEffect(() => {
        async function fetchHere() {
            await get_bom_detail_by_bom_id({bomId: bom_id})
        }

        fetchHere()
    }, []);

    useEffect(() => {
        if (bom_detail_by_bom_id !== undefined && bom_detail_by_bom_id === null) {
            window.history.back()
        }
    }, [bom_detail_by_bom_id]);
    return (
        <>
            {bom_detail_by_bom_id !== undefined && bom_detail_by_bom_id !== null && Object.keys(bom_detail_by_bom_id).length > 0 &&
            <h4 className="bs5 m-0 font-16 lh-1"><span
                className="me-2 text-black">{bom_detail_by_bom_id && bom_detail_by_bom_id.bomName}</span>
                <a onClick={() => editHandler(true)}><i className="fa fa-pencil  font-12"></i></a></h4>
            }
        </>
    );
}

export default BomName;